import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { TableWithPagination } from "../../globalComponents/TableWithPagination";
import { ToolBar } from "../../globalComponents/ToolBar";
import { Menu } from "antd";
import {
  StyledBoldText,
  StyledCard,
  StyledNormalText,
  StyledModal,
} from "../../globalComponents/styles";
import { useRouteMatch, Route, Switch, useHistory } from "react-router";
import { AdjustmentDetails } from "./AdjustmentDetails";
import { AdjustItem } from "./AdjustItem";
import {
  selectAdjustments,
  adjustmentsList,
  paginationProps,
  fetchAllAdjustments,
} from "./slice";
import { useDispatch, useSelector } from "react-redux";
import { Form, Popover, Space } from "antd";
import { getInput } from "../Items/AddItem";
import { FiMoreVertical } from "react-icons/fi";
import { Box, Paper } from "@material-ui/core";
import {
  CancelButton,
  TransaparentButton,
} from "../../globalComponents/Buttons";
import { ModalComponent } from "../../globalComponents/Modal";
import Services from "../../../services";
import { selectDashboard } from "../../Dashboard/slice";

// const data = [
//   {
//     date: "July, 27 2021",
//     warehouse: "Ojota Zone",
//     status: "Pending",
//     reference: "0900388YU",
//     adjustedBy: "Grace Jacobs",
//   },
//   {
//     date: "July, 27 2021",
//     warehouse: "Ojota Zone",
//     status: "Pending",
//     reference: "0900388YU",
//     adjustedBy: "Grace Jacobs",
//   },
//   {
//     date: "July, 27 2021",
//     warehouse: "Ojota Zone",
//     status: "Pending",
//     reference: "0900388YU",
//     adjustedBy: "Grace Jacobs",
//   },
//   {
//     date: "July, 27 2021",
//     warehouse: "Ojota Zone",
//     status: "Pending",
//     reference: "0900388YU",
//     adjustedBy: "Grace Jacobs",
//   },
//   {
//     date: "July, 27 2021",
//     warehouse: "Ojota Zone",
//     status: "Pending",
//     reference: "0900388YU",
//     adjustedBy: "Grace Jacobs",
//   },
// ];

export const InventoryAdjustment = (props) => {
  const [page, setPage] = React.useState(2);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const { paginationProps, adjustmentsList } = useSelector(selectAdjustments);
  console.log(adjustmentsList, "adjustmentsLists");
  const { url, path } = useRouteMatch();
  const history = useHistory();
  const dispatcher = useDispatch();
  const [searchItem, setSearchItem] = useState({});

  const [feedbackProps, setFeedbackProps] = useState({
    open: false,
    type: "",
    message: "",
  });
  const [deleteModalProps, setDeleteModalProps] = useState({
    visible: false,
    name: "",
    id: null,
    loading: false,
  });
  const [editModalProps, setEditModalProps] = useState({
    isVisible: false,
    selectedItemInput: [],
    loading: false,
    initialValues: {},
  });
  useEffect(() => {
    (async () => {
      await dispatcher(fetchAllAdjustments({ page: 0, size: 10 }));
    })();
    //  dispatcher(getAllTransfarOrder({ page: 0, size: 10 }));
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClick = (e) => {};
  const handleViewItemGroup = (id) => async () => {
    history.push(`${url}/${id}`);
    //  try {
    //   const response = await dispatcher(fetchSingleItemGroup({id}));
    //   console.log(response);
    // } catch (error) {
    //   console.log(error);
    // }
  };

  const gotoAdjustItem = () => {
    history.push(`${url}/adjust-item`);
  };

  const handleTableRow = (record, rowIndex) => {
    console.log(record, "record ad");
    return {
      onClick: (event) => {
        history.push(`${url}/adjustmentDetails/${record.id}`);
      },
    };
  };

  const handleIAdjustmentDelete = async () => {
    try {
      setDeleteModalProps((prevState) => ({ ...prevState, loading: true }));
      const response = await Services.deleteAdjustment({
        id: deleteModalProps.id,
      });
      await dispatcher(fetchAllAdjustments({ page: 0, size: 10 }));
      setFeedbackProps({
        type: "success",
        message: `${deleteModalProps.name} has been deleted`,
        open: true,
      });
      setDeleteModalProps((prevState) => ({
        ...prevState,
        loading: false,
        visible: false,
      }));
      // window.location.reload();
    } catch (error) {
      console.log(error);
      setDeleteModalProps((prevState) => ({ ...prevState, loading: false }));
      setFeedbackProps({
        type: "error",
        message: `Please try again`,
        open: true,
      });
    }
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "inventoryAdjustedDate",
      key: "inventoryAdjustedDate",
    },
    {
      title: "Warehouse Name",
      dataIndex: "warehouseName",
      key: "warehouseName",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Reference Number",
      dataIndex: "referenceNumber",
      key: "referenceNumber",
    },
    {
      title: "Adjusted by",
      dataIndex: "addedBy",
      key: "addedBy",
    },

    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: "5%",
      render: (data, allData) => {
        const content = (
          <Space direction="vertical" size="small">
            <p
              onClick={() => {
                const newData = data.map((item) => {
                  item.defaultValue = allData[item.name];
                  return getInput(item);
                });
                setEditModalProps((prevState) => ({
                  ...prevState,
                  selectedItemInput: newData,
                  isVisible: true,
                  initialValues: allData,
                }));
              }}
              style={{ cursor: "pointer" }}
            >
              Edit
            </p>
            <p
              onClick={handleViewItemGroup(allData.id)}
              style={{ cursor: "pointer" }}
            >
              View Detail
            </p>
            <p
              onClick={() =>
                setDeleteModalProps({
                  name: allData.groupName,
                  id: allData.id,
                  visible: true,
                })
              }
              style={{ color: "red", cursor: "pointer" }}
            >
              Delete
            </p>
          </Space>
        );
        return (
          <Popover content={content} trigger="click">
            <FiMoreVertical />
          </Popover>
        );
      },
    },
  ];

  const filteredList = adjustmentsList.filter((item) => item.id === searchItem);
  const displayItemlist =
    filteredList.length > 0 ? filteredList : adjustmentsList;

  return (
    <Switch>
      <Route exact path={path}>
        <ToolBar
          title="Inventory Adjustments"
          showtools
          onCreate={gotoAdjustItem}
          createButtonText="New Adjustment"
          valueName="warehouseName"
          dataList={adjustmentsList}
          setSearchItem={setSearchItem}
        />
        <StyledCard mt={2}>
          <TableWithPagination
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleChangePage={handleChangePage}
            columns={columns}
            dataSource={displayItemlist}
            // onRow={handleTableRow}
          />
        </StyledCard>
        <ModalComponent
          open={deleteModalProps.visible}
          onClose={() =>
            setDeleteModalProps((prevState) => ({
              ...prevState,
              visible: false,
            }))
          }
        >
          <Paper style={{ minWidth: "30vw", padding: "16px" }}>
            <Box>
              <StyledBoldText align="center" variant="subtitle1">
                Delete Item Group
              </StyledBoldText>
            </Box>
            <Box mt={3}>
              <StyledNormalText variant="body2" align="center">
                Do you want to delete <strong>{deleteModalProps.name}</strong>?
              </StyledNormalText>
            </Box>
            <Box p={3} display="flex" justifyContent="flex-end">
              <Box mr={2}>
                <TransaparentButton
                  onClick={() =>
                    setDeleteModalProps((prevState) => ({
                      ...prevState,
                      visible: false,
                    }))
                  }
                  text="Cancel"
                />
              </Box>
              <CancelButton
                loading={deleteModalProps.loading}
                onClick={handleIAdjustmentDelete}
                type="submit"
                text="Delete"
              />
            </Box>
          </Paper>
        </ModalComponent>
      </Route>
      <Route path={`${path}/adjust-item`}>
        <AdjustItem />
      </Route>

      <Route path={`${path}/:id`}>
        <AdjustmentDetails />
      </Route>
    </Switch>
  );
};
